<template>

    <div class="payment">
        <div v-if="!isLoading">
            <div class="mt-4 mb-4">
                <booking-summary></booking-summary>
            </div>

            <div class="payment-wrapper ">

                <div v-if="hasError" class="mb-4">
                    <info-box v-bind:type="'error'">
                        <template v-slot:body>
                            <span class="heading">
                                Error
                            </span>
                            <div>
                                <p>
                                    Sorry your booking is no longer in session, please begin your booking again.
                                </p>
                            </div>
                        </template>
                    </info-box>
                </div>



                <div class="mb-5">
                    <gift-vouchers-payment></gift-vouchers-payment>
                </div>

                <div class="has-shadow">
                    <to-pay v-bind:isTodayPayment="true"></to-pay>
                    <to-pay v-bind:isTodayPayment="false"></to-pay>

                </div>

                <Form @submit="onSubmit" @invalid-submit="onInvalidSubmit" :validation-schema="schema">
                    <div class="payment-wrapper">
                        <div class="gift-vouchers-payment bg-white  w-100 p-4">
                            <div class="col-24  g-0">
                                <fieldset>


                                    <div class="form-group">
                                        <div class="inner">
                                            <label class="control-label">Name On Card <em class="req">*</em></label>


                                            <Field name="cardHoldersName"
                                                   autocomplete="new-password"
                                                   type="text"
                                                   class="form-control"></Field>
                                            <ErrorMessage name="cardHoldersName" class="error-message" />

                                        </div>


                                    </div>


                                    <div class="form-group select-group">
                                        <div class="inner">
                                            <label class="control-label">Card Type <em class="req">*</em></label>

                                            <Field name="cardType"
                                                   autocomplete="new-password"
                                                   as="select"
                                                   class="form-select form-control">
                                                <option selected="" value="VS">Visa</option>
                                                <option value="AX">Amex</option>
                                                <option value="DI">Discover</option>
                                                <option value="MC">MasterCard</option>
                                                <option value="UM">UK Maestro</option>

                                            </Field>

                                            <ErrorMessage name="cardType" class="error-message" />
                                        </div>
                                    </div>


                                    <div class="form-group">
                                        <div class="inner">
                                            <label class="control-label">Card Number <em class="req">*</em></label>


                                            <Field name="cardNumber"
                                                   autocomplete="new-password"
                                                   type="text"
                                                   class="form-control"></Field>
                                            <ErrorMessage name="cardNumber" class="error-message" />

                                        </div>


                                    </div>

                                    <!-- ROW -->
                                    <div class="row">


                                        <div class="form-group select-group col-12">
                                            <div class="inner">
                                                <label class="control-label">
                                                    Expiry
                                                    Month <em class="req">*</em>
                                                </label>

                                                <Field name="expiryMonth"
                                                       autocomplete="new-password"
                                                       as="select"
                                                       class="form-select form-control">

                                                    <option value="01">01</option>
                                                    <option value="02">02</option>
                                                    <option value="03">03</option>
                                                    <option value="04">04</option>
                                                    <option value="05">05</option>
                                                    <option value="06">06</option>
                                                    <option value="07">07</option>
                                                    <option value="08">08</option>
                                                    <option value="09">09</option>
                                                    <option value="10">10</option>
                                                    <option value="11">11</option>
                                                    <option value="12">12</option>
                                                </Field>


                                                <ErrorMessage name="expiryMonth" class="error-message" />

                                            </div>
                                        </div>

                                        <div class="form-group select-group col-12">
                                            <div class="inner">
                                                <label class="control-label">
                                                    Expiry
                                                    Year <em class="req">*</em>
                                                </label>
                                                <Field name="expiryYear"
                                                       autocomplete="new-password"
                                                       as="select"
                                                       class="form-select form-control">
                                                    <option value="22">2022</option><option value="23">2023</option><option value="24">2024</option><option value="25">2025</option><option value="26">2026</option><option value="27">2027</option><option value="28">2028</option><option value="29">2029</option><option value="30">2030</option><option value="31">2031</option><option value="32">2032</option><option value="33">2033</option><option value="34">2034</option><option value="35">2035</option><option value="36">2036</option><option value="37">2037</option><option value="38">2038</option><option value="39">2039</option><option value="40">2040</option><option value="41">2041</option><option value="42">2042</option><option value="43">2043</option><option value="44">2044</option><option value="45">2045</option><option value="46">2046</option><option value="47">2047</option><option value="48">2048</option><option value="49">2049</option><option value="50">2050</option>
                                                </Field>


                                                <ErrorMessage name="expiryYear" class="error-message" />

                                            </div>
                                        </div>

                                    </div>

                                </fieldset>


                                <fieldset class="buttons">

                                    <button class="btn btn--slate-blue btn--continue btn--block"
                                            v-bind:disabled="isSubmitting"
                                            v-on:click="onContinue">
                                        PAY TO COMPLETE
                                    </button>


                                </fieldset>

                            </div>
                        </div>


                    </div>

                </Form>

            </div>
        </div>

        <div v-if="isLoading" class="d-flex justify-content-center">
            <loader></loader>
        </div>



        <actions-bar>
            <template v-slot:actions>
                <div class="row">
                    <div class="col-12">

                        <button v-on:click="onBack" class="btn btn--transparent btn--back">
                            Back
                        </button>
                    </div>
                </div>
            </template>
        </actions-bar>

    </div>



</template>

<script>

    import { Field, Form, ErrorMessage } from "vee-validate";
    import * as yup from "yup";

    import ActionsBar from '@/shared/components/ActionsBar.vue';
    import Loader from '@/shared/components/Loader.vue';
    import CurrentAction from '../components/CurrentAction.vue';
    import PaymentForm from '../components/PaymentForm.vue';
    import GiftVouchersPayment from '../components/GiftVouchersPayment.vue';
    import ToPay from '../components/ToPay.vue';

    import InfoBox from '@/shared/components/InfoBox.vue';
    import { store } from '../store/index';

    export default {
        name: 'StayPayment',
        components: {
            ActionsBar,
            CurrentAction,
            PaymentForm,
            GiftVouchersPayment,
            Loader,
            InfoBox,
            ToPay,
            Field,
            Form,
            ErrorMessage
        },
        computed: {
            session() {
                return store.getters.session
            },
            booking() {
                return store.getters.booking;
            },
        },
        data() {

            const schema = yup.object().shape({
                cardHoldersName: yup.string().required().label("Name On Card"),
                cardType: yup.string().required().label("Card type"),
                cardNumber: yup.string().required().label("Card number"),
                expiryMonth: yup.string().required().label("Expiry month"),
                expiryYear: yup.string().required().label("Expiry year"),

            });


            return {

                schema,
                hasError : false,
                paymentSession: null,
                isLoading: false,
                isSubmitting: false
            }
        },

        methods: {
            onBack: function () {
                this.$router.push({ name: 'stay_summary', params: { id: this.session.Id } });

            },
            onSubmit: function (values) {


                this.trackBeginPayment();
                this.hasError = false;
                this.isSubmitting = true;
                this.isLoading = true;


                let payload = values;

           
                store.dispatch("confirmBooking", payload).then(() => {
                    this.isSubmitting = false;
                    this.isLoading = false;
                    this.$router.push({ name: 'stay_confirmation', params: { id: this.session.Id } });
                }).catch(() => {
                    this.isSubmitting = false;
                    this.isLoading = false;
                    this.hasError = true;
                });

            },

            trackBeginPayment() {

                if (this.$gtm.enabled()) {

                    let items = [];
                    let total = 0;
                    for (let li in this.booking.legs) {

                        let leg = this.booking.legs[li];
                        items.push({
                            "item_id": leg.room.PMSCode + '-' + leg.rate.availableRate.RateCode,
                            "item_name": leg.room.DisplayName + ' - ' + leg.rate.availableRate.RateCode,
                            "item_brand": "Rockliffe Hall",
                            "quantity": 1,
                            "price": leg.rate.availableRate.Amount,
                            "item_category": "Room/Rate"
                        })



                        if (leg.includedPackages !== undefined && leg.includedPackages != null && leg.includedPackages.length) {
                            for (let pi = 0; pi < leg.includedPackages.length; pi++) {
                                let pkge = leg.includedPackages[pi];

                                items.push({
                                    "item_id": pkge.Code,
                                    "item_name": pkge.Code,
                                    "item_brand": "Rockliffe Hall",
                                    "quantity": +(pkge.QuantityRequired),
                                    "price": +(pkge.UnitPrice),
                                    "item_category": "Included Package"
                                })
                                total += +(pkge.UnitPrice) * +(pkge.QuantityRequired);
                            }


                        }


                        if (leg.packages !== undefined && leg.packages != null && leg.packages.length) {
                            for (let pIndex = 0; pIndex < leg.packages.length; pIndex++) {
                                let pkge2 = leg.packages[pIndex];

                                items.push({
                                    "item_id": pkge2.item.availability.Code,
                                    "item_name": pkge2.item.content.DisplayName,
                                    "item_brand": "Rockliffe Hall",
                                    "quantity": +(pkge2.quantity),
                                    "price": +(pkge2.item.availability.Amount),
                                    "item_category": "Package"
                                })
                                total += +(pkge2.item.availability.Amount) * +(pkge2.quantity);
                            }


                        }



                        total += +(leg.rate.availableRate.Amount);
                    }


                    window.dataLayer?.push({
                        'pageURL': '/stay/stay/payment',
                        'event': 'add_payment_info',
                        'value': total,
                        'curency': 'GBP',
                        'ecommerce': {
                            'items': items
                        }
                    });
                }
            }


        }
    }
</script>


<style src="@/shared/css/payment.css"></style>


<style scoped>
    .payment-wrapper .form-group {
        position: relative;
        z-index: 1;
        margin-bottom: 15px;
    }

        .payment-wrapper .form-group .inner {
            position: relative;
            border-width: 1px;
            border-style: solid;
            padding: 0;
            -webkit-transition: border-color .3s ease-in-out 0s;
            -moz-transition: border-color .3s ease-in-out 0s;
            -ms-transition: border-color .3s ease-in-out 0s;
            transition: border-color .3s ease-in-out 0s;
            border-color: rgba(0, 0, 0, 0.2);
        }

        .payment-wrapper .form-group .payment-wrapper .inner, .checkbox input, .payment-wrapper .radiobutton input {
            border-color: rgba(0, 0, 0, 0.2);
        }


    .payment-wrapper fieldset {
        margin: 0 0 16px;
        padding: 0;
        ;
        border: 0;
        min-width: 0;
    }


    .payment-wrapper .form-group .inner label {
        position: relative;
        z-index: 1;
        font-size: 14px;
        padding: 10px 15px 0;
    }


    .payment-wrapper label {
        font-weight: normal;
        display: block;
        cursor: pointer;
        max-width: 100%;
        margin-bottom: 5px;
    }

    .payment-wrapper .form-group .inner .form-control {
        position: relative;
        z-index: 1;
        border: 0 none;
        font-size: 15px;
        padding: 5px 15px 10px;
        height: auto;
        outline: 0 none !important;
    }



    .payment-wrapper em.req {
        font-style: normal;
        color: #e81f1f;
        color: rgba(232, 31, 31, 1);
    }


    .payment-wrapper select:focus,
    .payment-wrapper input:focus,
    .payment-wrapper input:hover,
    .payment-wrapper select,
    .payment-wrapper input {
        outline: 0 none !important;
        border-color: inherit;
        -webkit-box-shadow: none;
        box-shadow: none;
    }

    .booking form .payment-wrapper .error-message {
        padding: 5px 15px 10px;
        font-size: 14px;
    }

</style>
